<!-- @format -->
<invoice-provider-form-tag>

    <invoice-provider-area
            dataModel={invoiceProvider}
    ></invoice-provider-area>

    <div class="wrap_button margin-spacing-3_top">
        <div
                class="button button-primary"
                onclick="{ submit }"
                type="button"
                value="登録情報を変更する"
                data-target=""
        ><span class="icon_documents"></span>登録情報を変更する
        </div>
    </div>

    <script>
        import bindingTag from "@tags/parts/info/invoice-provider/binding.riot";
        import invoiceProviderForm from "@tags/parts/info/invoice-provider/invoice-provider-form.riot";
        import invoiceProvider from "@model/invoiceProvider/api";

        export default {
            components: {
                'binding-tag': bindingTag,
                'invoice-provider-form-tag': invoiceProviderForm,
            },
            invoiceProvider: invoiceProvider,
            state: {
                invoice_provider_number_error_message: '',
            },
            onBeforeMount() {
                this.invoiceProvider.trigger('fetch')
            },
            onMounted() {
                window.$("#birthday").flatpickr({
                    locale: "ja",
                });
            },
            submit(e) {
                e.preventDefault()
                if (!this.required_vaild()) {
                    alert('入力されていない項目があります。')
                    return false;
                }
                this.invoiceProvider.trigger('save')
            },
            required_vaild() {
                let isvalid = true
                const fields = document.getElementsByClassName('text_input')
                let invoice_provider_number_element = null;
                let invoice_provider_number_body = "";
                let invoice_provider_state = "";
                for (let item of fields) {

                    let pass = true;
                    let message = '入力してください'
                    switch (item.id) {
                        case 'invoice_provider_number_body':
                            invoice_provider_number_element = item;
                            invoice_provider_number_body = item.value;
                            invoice_provider_state = this.invoiceProvider.item.invoice_provider_state;
                            break;
                        default:
                            if (!item.value) {
                                pass = false;
                            }
                            break;
                    }
                    if (!pass && !item.classList.contains('is-error')) {
                        item.classList.add('is-error')
                        const div = document.createElement('div')
                        div.textContent = message
                        div.classList.add('error')
                        item.parentElement.appendChild(div)
                        isvalid = false
                    }

                    if ((invoice_provider_state === "yes") && (invoice_provider_number_body === "")) {
                        this.invoiceProvider.trigger("change_invoice_provider_number_error_on");
                    }
                }
                return isvalid
            }
        }
    </script>
</invoice-provider-form-tag>